"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { CalendarCheck, Car, Droplets, Key, ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  icon: CalendarCheck,
  title: "Inspection",
  description: "We begin by looking over every window to see any windows that need different care so that we are able to leave every window spotless."
}, {
  icon: Droplets,
  title: "Precision Clean",
  description: "Our specialists perform a deep hand-scrubbing of every pane using eco-friendly, professional-grade solutions."
}, {
  icon: Car,
  title: "Frame Cleaning",
  description: "We don't just clean glass; we clean the frames and tracks to remove all debris, leaving a showroom finish."
}, {
  icon: Key,
  title: "Final Inspection",
  description: "A rigorous 6SPC walkthrough ensures every window meets our luxury standards before we consider the job done."
}];
export default function The6StarProcess() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="221501" id="the-6spc-process" className="bg-background text-foreground py-24 relative overflow-hidden">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-primary/5 blur-[120px] rounded-lg pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10" ref={ref}>
        <div className={`text-center max-w-3xl mx-auto mb-20 transition-all duration-700 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-sm font-default font-bold tracking-widest text-muted-foreground uppercase mb-3">
            The Methodology
          </h2>
          <h3 className="text-4xl md:text-5xl font-default font-bold mb-6 text-foreground"><span className="text-primary">The 6SPC Process</span></h3>
          <p className="text-lg text-muted-foreground font-sans">
            Experience a meticulous window cleaning journey designed for the most 
            discerning homeowners in the GTA.
          </p>
        </div>

        <div className="relative max-w-6xl mx-auto">
          {}
          <div className="hidden md:block absolute top-12 left-[12.5%] right-[12.5%] h-px border-t-2 border-dashed border-border/30 z-0" />
          
          {}
          <div className="block md:hidden absolute top-0 bottom-0 left-1/2 -translate-x-1/2 w-px border-l-2 border-dashed border-border/30 z-0" />

          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-6 relative z-10">
            {steps.map((step, i) => {
            const Icon = step.icon;
            return <div key={i} data-index={i} className={`flex flex-col items-center text-center transition-all duration-700 delay-${i * 200} transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
              transitionDelay: `${i * 150}ms`
            }}>
                  {}
                  <div className="relative flex items-center justify-center w-24 h-24 rounded-lg bg-card border border-border ring-8 ring-primary/5 mb-8 z-10 group hover:ring-primary/10 hover:border-primary/50 transition-all duration-300 shadow-md">
                    <div className="absolute inset-0 rounded-lg bg-primary/5 group-hover:bg-primary/10 transition-colors duration-300" />
                    <Icon className="w-10 h-10 text-foreground relative z-20" />
                    
                    {}
                    <div className="absolute -top-2 -right-2 w-8 h-8 rounded-lg bg-primary text-primary-foreground flex items-center justify-center text-sm font-default font-bold shadow-lg">
                      {i + 1}
                    </div>
                  </div>

                  {}
                  <div className="bg-card/40 backdrop-blur-md border border-border/50 rounded-lg p-6 w-full h-full flex flex-col items-center hover:bg-card/60 transition-colors duration-300 shadow-xl">
                    <h4 className="text-xl font-default font-bold mb-3 text-foreground">
                      {step.title}
                    </h4>
                    <p className="text-muted-foreground text-sm leading-relaxed font-sans">
                      {step.description}
                    </p>
                  </div>
                </div>;
          })}
          </div>
        </div>

        <div className={`mt-20 text-center transition-all duration-700 delay-700 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Button asChild size="lg" className="rounded-md px-8 h-14 text-base font-default bg-primary text-primary-foreground hover:opacity-90 transition-opacity">
            <Link to="/ExpertisePage">
              Explore Our Expertise
              <ArrowRight className="ml-2 w-5 h-5" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}